<template>
    <div ref="shareCardDom" v-loading="loading">
        <div class="img-qrcode-div">
            <div>
                <el-image class="card-img" :src="imgUrl" >
                    <template #error>
                        <img class="card-img" :src="`${staticPath}static/images/defaultCard.jpg`">
                    </template>
                </el-image>
            </div>

            <div>
                <div>
                    <qrcodeComponents v-if="null !== shareUrl" :url="shareUrl" :width="qrcodeWidth" :height="qrcodeHeight" />
                </div>

                <div style="margin-top: 15px">
                    <span tkey="鏈接">{{i18n.tkey("lang_link")}}：</span><span>{{shareUrl}}</span>
                </div>
            </div>
        </div>

        <ul class="share-content-ul content-part" v-show="showReceiveEmailInput === false">
           <li>
               <span tkey="分享內容">{{i18n.tkey("lang_share_content")}}：</span>
           </li>

            <li>
                <el-input v-model="shareContent" :placeholder="i18n.tkey('lang_share_content')" clearable />
            </li>

            <li class="icon-share-part">
                <span tkey="發送方式">{{i18n.tkey("lang_sending_method")}}：</span>
            </li>

            <li class="icons-part">
                <shareIcon @click="copyShareUrl"><font-awesome-icon icon="fa-solid fa-copy" style="color: #909399" /></shareIcon>
                <shareIcon @click="copyShareWhatsappUrl"><font-awesome-icon icon="fa-brands fa-whatsapp" style="color: #909399" /></shareIcon>
                <shareIcon @click="facebookShare"><font-awesome-icon icon="fa-brands fa-square-facebook" style="color: #3c589b;" /></shareIcon>
                <shareIcon @click="pinteresShare"><font-awesome-icon icon="fa-brands fa-square-pinterest" style="color: #c7453c;" /></shareIcon>
                <shareIcon @click="stumbleuponShare"><font-awesome-icon icon="fa-brands fa-stumbleupon-circle" style="color: #ee4c2c;" /></shareIcon>
                <shareIcon @click="toggleSharePart"><font-awesome-icon icon="fa-regular fa-envelope" style="color: #79bbff" /></shareIcon>
            </li>
        </ul>

        <div class="content-part" v-show="showReceiveEmailInput === true">
            <div style="text-align: left; line-height: 2;">
                <span style="float: right; font-size: 2em; line-height: 1; cursor: pointer;" @click="toggleSharePart"><font-awesome-icon icon="fa-solid fa-xmark" style="color: #F56C6C;"/></span>
                <span tkey="請輸入接收分享的郵箱地址">{{i18n.tkey("lang_input_share_email_address")}}</span>
            </div>

            <el-input v-model="receiveEmail" :placeholder="i18n.tkey('lang_receive_email_address')" clearable />
            <el-button type="primary" @click="sendShareEmail" style="margin-top: 15px;" tkey="發送">{{i18n.tkey("lang_send")}}</el-button>
        </div>
    </div>
</template>

<script setup>
    import {getCurrentInstance, onMounted, ref, toRef, computed, inject} from "vue";
    import util from "@/util/util"
    import api from "@/request/api"
    import { useShareinfo } from '@/stores/shareinfo'
    import { useUserinfo } from '@/stores/userinfo'
    import qrcodeComponents from "@/components/shopopee/common/qrcodeComponents"
    import shareIcon from "@/components/shopopee/common/shareIcon"
    import copy from "clipboard-copy"
    //导入图标
    import { library } from '@fortawesome/fontawesome-svg-core'
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
    import { faCopy } from '@fortawesome/free-solid-svg-icons'
    import { faSquareFacebook, faSquarePinterest, faStumbleuponCircle } from '@fortawesome/free-brands-svg-icons'
    import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
    import { faWhatsapp } from '@fortawesome/free-brands-svg-icons'

    library.add(faSquareFacebook, faSquarePinterest, faStumbleuponCircle, faEnvelope, faCopy, faWhatsapp)

    const shareInfoRef = toRef(useShareinfo())
    const userInfoRef = toRef(useUserinfo())

    const i18n = inject("i18n")

    const { proxy } = getCurrentInstance()

    const cardSpan = ref(24)
    const qrcodeSpan = ref(24)

    const componentWidth = ref(375)
    const loading = ref(true)

    const cardObj = ref(null)
    const imgUrl = ref(null)

    const shareUrl = ref(null)
    const shareContent = ref("")

    const qrcodeWidth = ref(150)
    const qrcodeHeight = ref(150)

    const receiveEmail = ref("")
    const showReceiveEmailInput = ref(false)

    const shareWhatsappUrl = ref(null)

    function getCardObj(callback){
        const request = api.querySimpleMemberWorkById
        const params = request.getParams()
        params.id = shareInfoRef.value.cardId

        request.send(params, callback)
    }

    function fillCardObj(res){
        loading.value = false
        if (res.code == 200){
            cardObj.value = res.detail
            imgUrl.value = util.generateCardImgUrl(res.detail.cardinfo)
            shareUrl.value = util.generateCardShareUrl(res.detail.id)
            shareWhatsappUrl.value = util.generateCardWhatsappShareUrl(res.detail.id)
            shareContent.value = `${i18n.tkey("lang_share_Preset_content_1")}${res.detail.name}${i18n.tkey("lang_share_Preset_content_2")}`
        }
    }

    function facebookShare(){
        const titleStr = userInfoRef.value.name
        const content = shareContent.value.trim()
        const metaArr = [
            'og:url', encodeURIComponent(shareUrl.value),
            'og:title', titleStr,
            'og:description', content,
            'og:image', `${proxy.$ShopopeeUrl}/MPic/ZZ/${cardObj.value.cardinfo}`
        ]
        const metaParams = metaArr.toString()
        // console.log(metaParams)
        const shareStr = `${proxy.$ShopopeeUrl}/sharePage?mate=${encodeURIComponent(metaParams)}`
        window.open('http://www.facebook.com/sharer.php?u='+encodeURIComponent(shareStr)+'&t='+encodeURIComponent(document.title),'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');
    }

    function pinteresShare(){
        const titleStr = userInfoRef.value.name

        window.open('https://www.pinterest.com/pin/create/button/?url='+encodeURIComponent(shareUrl.value)+"&media="+encodeURIComponent(`${proxy.$ShopopeeUrl}/MPic/ZZ/${cardObj.value.cardinfo}`)+'&description='+titleStr,'_blank','toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');
    }

    function stumbleuponShare() {
        const imgstr = `${proxy.$ShopopeeUrl}/MPic/ZZ/${cardObj.value.cardinfo}`

        const titleStr = userInfoRef.value.name

        window.open('https://www.stumbleupon.com/submit?url=' + encodeURIComponent(shareUrl) + '&title=' + titleStr + "&media=" + encodeURIComponent(imgstr), '_blank', 'toolbar=yes, location=yes, directories=no, status=no, menubar=yes, scrollbars=yes, resizable=no, copyhistory=yes, width=600, height=450,top=100,left=350');

    }

    function copyShareUrl(){
        copy(shareUrl.value)
        util.alertSuccess(i18n.tkey("lang_copy_success"))
    }

    function copyShareWhatsappUrl() {
        location.href = shareWhatsappUrl.value
        // copy(shareWhatsappUrl.value)
        // util.alertSuccess("已將內容複製到剪貼板")
    }

    function toggleSharePart(){
        receiveEmail.value = ""
        showReceiveEmailInput.value = !showReceiveEmailInput.value
    }

    function sendShareEmail(){
        if (util.emailCheck(receiveEmail.value)){
            loading.value = true

            const request = api.sendMemberworkShareEmail
            const params = request.getParams()
            params.email = receiveEmail.value
            params.url = shareUrl.value
            params.content = shareContent.value
            params.userId = userInfoRef.value.id
            params.img = util.generateCardImgUrl(cardObj.value.cardinfo)

            request.send(
                params,
                (res) => {
                    loading.value = false
                    if (res.code == 200){
                        util.alertSuccess(i18n.tkey("lang_share_success"))
                        toggleSharePart()
                    }else{
                        util.alertError(i18n.tkey("lang_request_error"))
                    }
                },
                () => {
                    loading.value = false
                    util.alertError(i18n.tkey("lang_request_error"))
                }
            )
        }else{
            util.alertError(i18n.tkey("lang_error_format_email"))
        }
    }

    onMounted(() => {
        componentWidth.value = proxy.$refs.shareCardDom.offsetWidth

        if (componentWidth.value >= 768){
            cardSpan.value = 14
            qrcodeSpan.value = 10

            qrcodeWidth.value = 200
            qrcodeHeight.value = 200
        }

        if (null != shareInfoRef.value.cardId){
            getCardObj(fillCardObj)
        }else{
            loading.value = false
        }
    })
</script>

<style scoped>
    .img-qrcode-div {
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
    }

    .card-img {
        margin-bottom: 10px;
        max-width: 425px;
        max-height: 275px;
        object-fit: scale-down;
    }

    .share-content-ul {
        margin: 0;
        list-style: none;
        text-align: left;
        padding-left: 0;
        line-height: 2;
    }

    .content-part {
        margin-top: 25px;
    }

    .icon-share-part {
        margin-top: 10px;
    }

    .icons-part {
        padding: 10px;
    }
</style>